import { useEffect, useRef, useState } from 'react';

import propTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import useI18n from '../../hooks/use-i18n';
import { countryDialCodeData } from '../../language.config';
import { getCountryCodeByIsd } from '../../utils/utils';

const PhoneNumberInput = (props) => {
  const { values, updateForm, error } = props;

  const i18n = useI18n();

  const addressDetails = i18n.t('account_address_details');

  const dropDownRef = useRef();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const handleClick = (e) => {
    if (dropDownRef.current && dropDownRef.current.contains(e.target)) {
      return;
    }
    setIsOpen(false);
  };

  return (
    <div className="signup-input-wrapper">
      <Row>
        <Col sm="4" xs="5" className="p-custom1-r dropdown-flag-wrapper">
          <div
            className="input-default btn text-left"
            onClick={() => setIsOpen(!isOpen)}
            role="presentation"
            ref={dropDownRef}
          >
            <div className="flag-box">
              <div
                className={`iti-flag ${getCountryCodeByIsd(values.isdCode)}`}
              />
            </div>
            <span className="isd-code">{values.isdCode}</span>
            <img src="/img/icon_formarrow.svg" alt="arrow" />
            <ul
              className={`country-list ${isOpen ? 'show' : 'hide'}`}
              id="country-listbox"
            >
              {Object.keys(countryDialCodeData).map((key) => (
                <li
                  className="country standard"
                  role="presentation"
                  key={key}
                  onClick={() => {
                    updateForm({
                      isdCode: countryDialCodeData[key].dialCode,
                      countryCode: key
                    });
                  }}
                >
                  <div className="flag-box">
                    <div className={`iti-flag ${key}`} />
                  </div>
                  <span className="country-name">
                    {countryDialCodeData[key].name}
                  </span>
                  <span className="dial-code">
                    {countryDialCodeData[key].dialCode}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="label">{addressDetails.country_code}</div>
        </Col>
        <Col xs="7" sm="8" className="p-custom1-l">
          <div
            className={`input-fieldRoot ${error ? 'warning' : 'no-warning'}`}
          >
            <input
              type="text"
              placeholder=" "
              value={values.phoneNumber}
              autoComplete="phone"
              onChange={(e) => updateForm({ phoneNumber: e.target.value })}
            />
            <label
              data-shrink="false"
              htmlFor="phoneNumber"
              id="phoneNumber-label"
            >
              {addressDetails.phone_number}
            </label>
          </div>
          {error && <span className="input-error">{error}</span>}
        </Col>
      </Row>
    </div>
  );
};

PhoneNumberInput.propTypes = {
  error: propTypes.string.isRequired,
  updateForm: propTypes.func.isRequired,
  values: propTypes.shape().isRequired
};

export default PhoneNumberInput;
